import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  resource,
} from '@angular/core';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { TooltipDirective } from '@core/directives/tooltip.directive';
import { SocketService } from '@core/services/socket.service';
import { AppearanceEntry, TrendItem } from '../../trends.interface';
import {
  BeTrendEvent,
  describeTrendError,
  mapTrendEvent,
  unwrapTrendRows,
} from '../../trend-event.mapper';

@Component({
  selector: 'app-appearances-modal',
  standalone: true,
  imports: [DatePipe, CurrencyPipe, TooltipDirective],
  templateUrl: './appearances-modal.component.html',
  styleUrl: './appearances-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'modal-container flex flex-col' },
})
export class AppearancesModalComponent {
  private readonly socketService = inject(SocketService);

  item = input<TrendItem>();

  itemName = computed(() => this.item()?.name ?? 'Unknown Item');

  readonly entriesResource = resource({
    params: () => {
      const skin = this.item()?.name;
      return skin ? { skin } : undefined;
    },
    loader: async ({ params }) => {
      // silent — the modal renders a normalized error row instead
      const response = await this.socketService.emit(
        'admin_load_trend_skin',
        { skin: params.skin },
        5000,
        true
      );
      // TODO: remove once the admin_load_trend_skin contract is verified against real data
      console.log('[trends] admin_load_trend_skin response', response);
      return unwrapTrendRows<BeTrendEvent>(response, 'trends').map(mapTrendEvent);
    },
  });

  entries = computed<AppearanceEntry[]>(() =>
    this.entriesResource.hasValue() ? this.entriesResource.value() : []
  );

  errorText = computed(() => {
    const err = this.entriesResource.error();
    return err ? describeTrendError(err) : '';
  });
}
